module.exports = __webpack_public_path__ + "img/moppet.51038fc8.png";